import React, { memo } from 'react';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'BONO 1 — Banco de Experimentos Express',
  desc: '40 prácticas seguras. Prácticas rápidas para explicar conceptos con evidencia, incluso con materiales simples.',
  img: 'https://cdn.magicpatterns.com/uploads/grSrCWvkYRmGTqRh3qdNLX/bono1.png'
}, {
  title: 'BONO 2 — Evaluaciones Premium A/B',
  desc: '60+ pruebas y quizzes. Pruebas listas por unidad con versiones A/B, claves y exit tickets.',
  img: 'https://cdn.magicpatterns.com/uploads/tn1pDDJCEHEPMppFasdmLr/bono2.png'
}, {
  title: 'BONO 3 — Kit Visual Científico',
  desc: 'Infografías + mapas conceptuales imprimibles. Recursos visuales para que entiendan sin memorizar a ciegas.',
  img: 'https://cdn.magicpatterns.com/uploads/dXqV1muJSjGaran9mJFchj/bono3.png'
}, {
  title: 'BONO 4 — Planificación Perfecta Ciencias',
  desc: 'Calendario anual + secuencias didácticas + planificaciones semanales editables.',
  img: 'https://cdn.magicpatterns.com/uploads/wB9v6rrxXYqFBfNjDwVTS6/bono4.png'
}];
export const BonusSection: React.FC = () => {
  return <section className="py-16 bg-gradient-to-b from-amber-50 to-white" data-id="element-23">
      <div className="container mx-auto px-4" data-id="element-24">
        <div className="text-center mb-12" data-id="element-25">
          <span className="inline-block bg-amber-100 text-amber-800 px-4 py-1 rounded-full font-bold text-sm mb-4" data-id="element-26">
            SOLO POR HOY
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-27">
            Bonos incluidos <span className="text-amber-600" data-id="element-28">(GRATIS)</span>
          </h2>
          <p className="text-lg text-gray-600 mt-2" data-id="element-29">
            Para que el año quede aún más resuelto
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-30">
          {bonuses.map((bonus, index) => <div key={index} className="bg-white p-6 rounded-2xl shadow-lg border border-amber-100 flex flex-col md:flex-row gap-6 items-center" data-id="element-31">
              <div className="w-full md:w-1/3 flex-shrink-0" data-id="element-32">
                <img src={bonus.img} alt={bonus.title} className="w-full h-auto rounded-lg shadow-md transform hover:scale-105 transition-transform duration-300" data-id="element-33" />
              </div>
              <div className="flex-1 text-center md:text-left" data-id="element-34">
                <div className="flex items-center justify-center md:justify-start gap-2 mb-2" data-id="element-35">
                  <Gift className="w-5 h-5 text-amber-500" data-id="element-36" />
                  <span className="text-xs font-bold text-amber-500 uppercase tracking-wider" data-id="element-37">
                    Regalo #{index + 1}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-38">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-39">{bonus.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};